import { HTMLAttributes } from 'react';
import { JoveLogoLoading, JoveModal } from '@jove-frontend/mui';
import clsx from 'clsx';

type DialogWrapperProps = HTMLAttributes<HTMLDivElement> & {
  loading?: boolean;
  width?: number | string;
};

const DialogWrapper = (props: DialogWrapperProps) => {
  const { children, loading, className, width = '700px' } = props;

  return (
    <JoveModal
      open={true}
      hideMask={false}
      containerWidth="100%"
      containerHeight="100%"
      containerClassName="items-center"
    >
      <div
        className={clsx(
          'flex max-h-[90%] flex-col overflow-hidden rounded-2xl bg-white',
          { relative: loading },
          className
        )}
        style={{ width }}
      >
        {loading && <JoveLogoLoading />}
        {children}
      </div>
    </JoveModal>
  );
};

export default DialogWrapper;
